import * as React from 'react'
import { Button, Row, Col } from 'react-bootstrap'
import AdGroupHeader from './campaignSettings/AdGroupHeader'
import ArticleTabs from './articleManagement/ArticleTabs'
import EditorContentComponent from './editorContent/EditorContent'
import ArticlePreview from './articleManagement/ArticlePreview'

interface Props {
	activeArticleTab: string
	title: string
	isDirty: boolean
	isFullPage?: boolean
	className?: string
	onTitleChange: (newTitle: string) => void
	onArticleTabSelect: (tabKey: string) => void
	onSave: () => void
	onCancel: () => void
}

const TrueNativeEditor = ({
	activeArticleTab,
	title,
	isDirty,
	isFullPage = false,
	className = '',
	onTitleChange,
	onArticleTabSelect,
	onSave,
	onCancel,
}: Props) => {
	const containerClass = isFullPage ? 'true-native-editor--fullpage' : 'true-native-editor--embedded'

	return (
		<div className={`true-native-editor ${containerClass} ${className}`}>
			<div className="editor-content">
				{/* Page Title Section */}
				<Row style={{ marginBottom: '20px' }}>
					<Col md={12}>
						<h2
							style={{
								fontFamily: 'ES Allianz, Arial, sans-serif',
								fontWeight: 500,
								fontSize: '24px',
								lineHeight: '1.2',
								color: '#033542',
								margin: '0 0 10px 0',
							}}
						>
							Create True Native Articles for your campaign
						</h2>
					</Col>
				</Row>

				{/* Article Tabs Section */}
				<Row>
					<Col md={12}>
						<ArticleTabs activeTab={activeArticleTab} onTabSelect={onArticleTabSelect} />
					</Col>
				</Row>

				{/* Article Header Section */}
				<Row>
					<Col md={12}>
						<AdGroupHeader title={title} onTitleChange={onTitleChange} />
					</Col>
				</Row>

				{/* Editor Content Section */}
				<Row>
					<Col md={12}>
						<EditorContentComponent />
					</Col>
				</Row>

				{/* Preview Section */}
				<ArticlePreview />

				{/* Bottom Actions */}
				<Row style={{ marginTop: '30px' }}>
					<Col md={12}>
						<div className="d-flex justify-content-end">
							<Button onClick={onCancel} className="me-2">
								Cancel
							</Button>
							<Button bsStyle="primary" onClick={onSave}>
								Save Article {isDirty && '*'}
							</Button>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default TrueNativeEditor
